
import { Options, Vue } from 'vue-class-component';
import Popper from 'vue3-popper';
import AppointmentService from "@/services/AppointmentService";
import { RecordIdentifier } from "@/data/global";
import { Appointment } from "@/data/appointments";
import { formatDatetimeWithDayLabel, formatDateWithDayLabel, formatTime } from "@/utils/helpers";
import AppointmentEnrollmentStatus from "@/components/AppointmentEnrollmentStatus.vue";
import RegionCourses from "@/components/RegionCourses.vue";


@Options({
    props: {
        appointment: {
            type: [Object, Number],
            required: false,
            default: null,
        },
        /*showCoursesButton: {
            type: Boolean,
            required: false,
            default: false,
        },*/
        shown: {
            type: Boolean,
            required: true,
        }
    },
    components: {
        Popper,
        AppointmentEnrollmentStatus,
        RegionCourses,
    },
    methods: {
        formatDatetimeWithDayLabel,
        formatDateWithDayLabel,
        formatTime,
    },
    emits: [
        'close',
        'enrollmentStatusChange',
    ]
})
export default class AppointmentDetailModal extends Vue {
    appointment: Appointment|RecordIdentifier|null = null

    appointmentLocal: Appointment|null = null

    shown!: boolean

    loading = false

    currencyFormatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
    })

    loadAppointment(appointmentId: number) {
        this.loading = true;
        return AppointmentService.getAppointment(appointmentId).then(result => {
            this.appointmentLocal = result.data.data as Appointment;
        }).finally(() => this.loading = false);
    }

    onEnrollmentStatusChange() {
        this.$emit('enrollmentStatusChange');
    }

    closeModal() {
        this.$emit('close');
    }

    get description() {
        return /*this.course?.info_text ||*/ this.appointmentLocal?.course?.course_type.description || null;
    }

    get descriptionLines() {
        if( !this.description ) {
            return [];
        }

        return this.description.split("\n");
    }

    mounted() {
        this.$watch('appointment', (val: Appointment|RecordIdentifier|null) => {
            // console.log('appointment changed', JSON.stringify(val, null, 2));

            if( val === null ) {
                this.appointmentLocal = null;
                return;
            }

            if( typeof val === 'number' ) {
                this.appointmentLocal = null;
                this.loadAppointment(val);
                return;
            }

            // appointment given by object
            this.appointmentLocal = JSON.parse(JSON.stringify(val));
        }, { immediate: true });

        /*
        this.$watch('shown', (newShown: boolean) => {
            if( newShown ) {
                // console.log('tmp SHOW MODAL AppointmentDetailModal');
            }
        }, { immediate: true });
        */
    }
}
